import { useTreasureApi, ApiKeys } from 'hooks/api/use-treasure-api';
import { useQuery, UseQueryResult } from 'react-query';
import { ReactQueryKeys } from 'enums';

export const useLegalEntityTypes = (): UseQueryResult<any> => {
  const { treasureApi } = useTreasureApi(ApiKeys.Business);

  return useQuery([ReactQueryKeys.LegalEntityTypes], async () => {
    const response = await treasureApi().get('/lookups/typeOfLegalEntity');

    return response.data;
  });
};
